import { FC } from 'react'
import { useQuery } from 'react-query'
import { fetchWorks } from 'src/services'
import Loading from 'src/components/Loading/Loading'
import Layout from 'src/containers/Layout/Layout'
import WorkList from 'src/containers/Work/WorkList'

const WorkListPage: FC = () => {
  const { data, isFetching, isLoading } = useQuery('works', () => fetchWorks())
  if (isFetching || isLoading || !data) return <Loading />
  return (
    <Layout>
      <WorkList works={data} />
    </Layout>
  )
}

export default WorkListPage
